<template>
  <span v-bind:style="styling">
    {{formatDate(props.row[props.column])}}
  </span>
</template>


<script>
  import moment from 'moment';
  
  const pastDue = (date) => {
    if (!moment(date).isValid()) return false;

    return moment(date).isBefore(moment(), 'day');
  }
  
  export default {
    name: 'AsComments',
    props: {
      
      props: [Array, Object],
      
      styling: {
        type: [Object, Array, String],
        default: function () {
          return pastDue(this.props.row[this.props.column]) ? 'color:#CC0000' : ''
        }
      }
    },
    methods: {
      
      pastDue,
      
      formatDate (date) {
        if (!moment(date).isValid()) return '-';

        return moment(date).format('DD-MMM-YYYY')
      },
    },
    
    data () {
      return {};
    }
  };
</script>
